import React, { useContext } from 'react';
import { toCurrency, toFormattedDate } from '@app/utilities';
import './PendingAuthorizations.css';
import { AccountContext } from '../AccountContext';
import { useGetDeclinedAuthorizations } from '@app/sdk';
import { ColDef } from 'ag-grid-community';
import { Table } from '@app/shared';
import { Segment } from 'semantic-ui-react';

export default function DeclinedAuthorizations() {
  const { accountId } = useContext(AccountContext);
  const { data: declinedAuthorizations, isLoading: loading } = useGetDeclinedAuthorizations({ accountId });

  const colDefs: ColDef[] = [
    {
      field: 'authorisationDate',
      headerName: 'Authorisation Date',
      valueFormatter: (params) => toFormattedDate(params.value, 'yyyy-MM-dd HH:mm:ss'),
      sort: 'desc',
    },
    { field: 'description', headerName: 'Description' },
    { field: 'declineReason', headerName: 'Decline Reason' },
    { field: 'amount.value', headerName: 'Amount', valueFormatter: (params) => toCurrency(params.value) },
    { field: 'remainingFloat', headerName: 'Remaining Float', valueFormatter: (params) => toCurrency(params.value) },
  ];

  return (
    <Segment style={{ height: '430px' }}>
      <h2 className="ui header">
        Declined Authorizations{loading && <div className="ui active centered inline loader" />}
      </h2>
      {declinedAuthorizations && (
        <div style={{ height: '300px' }}>
          <Table items={declinedAuthorizations} columnDefs={colDefs} />
        </div>
      )}
    </Segment>
  );
}
